import styled from 'styled-components';

export const StyledLinkButton = styled.div`
  text-align: center;

  & a {
    height: 50px;
    /* width: 120px; */

    & button {
      cursor: pointer;
      // min-width: 120px;
      font-size: 16px;
      font-weight: 500;
      letter-spacing: 0.02px;
      line-height: 19px;
      text-align: center;
      border: none;
      border-radius: 10px;

      @media screen and (max-width: 800px) {
        min-width: 80px;

        & span{
          height: 40px;
          display: flex;
          justify-content: center;
          flex-direction: column;
        }
      }
    
    }
  }
`;

export const StyledAPButton = styled.div`
  text-align: center;
  display: block;
  min-width: 42px;
  border-radius: 12px;
  border: 2px solid #1DBC7D;

  & a {
    height: 50px;
    /* width: 120px; */

    & button {
      cursor: pointer;
      text-align: center;
      border: none;
      border-radius: 10px;

      @media screen and (max-width: 800px) {

        & span{
          height: 40px;
          display: flex;
          justify-content: center;
          flex-direction: column;
        }
      }
    
    }
  }
`;

export const StyledMetricsButton = styled.div`
  text-align: center;
  display: block;
  min-width: 32px;
  border-radius: 12px;

  & a {
    height: 32px;
    /* width: 120px; */

    & button {
      cursor: pointer;
      text-align: center;
      border: none;
      border-radius: 10px;

      @media screen and (max-width: 800px) {

        & span{
          height: 32px;
          display: flex;
          justify-content: center;
          flex-direction: column;
        }
      }
    
    }
  }
`;
